import {Component, Input, OnInit} from '@angular/core';
import {OtherAsset} from '../../class/other-asset';
import {WelfareResultService} from '../../service/welfare-result.service';

@Component({
    selector: 'app-asset-other',
    templateUrl: './asset-other.component.html',
    styleUrls: ['./asset-other.component.css']
})
export class AssetOtherComponent implements OnInit {

    @Input()
    asset: OtherAsset;

    constructor(private welfareService: WelfareResultService) {
    }

    ngOnInit() {
    }

    deleteAsset() {
        this.welfareService.removeAsset(this.asset);
    }

}
